/* Keep product context in a customer-controlled, unsent contact message. */
(() => {
  'use strict';
  const field = document.getElementById('pw-contact-message');
  if (!field || field.value.trim()) return;
  const params = new URLSearchParams(window.location.search);
  const name = params.get('product');
  const path = params.get('product_path');
  if (!name || !path || name.length > 500 || path.length > 1000) return;
  try {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*\/?$/.test(url.pathname) || url.search || url.hash) return;
    const cleanName = name.replace(/[\x00-\x1f\x7f]/g, ' ').trim();
    if (!cleanName) return;
    field.value = `${field.dataset.productLabel} ${cleanName}\n${url.href}\n\n${field.dataset.questionLabel}\n`;
  } catch (_) { /* Invalid query parameters leave the form untouched. */ }
})();
